import React from "react";
import { Form, Formik, Field } from "formik";

export default function RejectModal({ closeModal, rejectRequest, request }) {
  return (
    <React.Fragment>
      <h4 style={{ color: "#000" }}>Reject Leave Request</h4>
      <Formik
        initialValues={{
          reason_for_rejection: "",
        }}
        onSubmit={async (values, { setSubmitting }) => {
          closeModal();
          rejectRequest(request, values.reason_for_rejection);
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Enter the reason for rejection{" "}
                    <span className="text-danger"> * </span>
                  </label>
                  <Field
                    name="reason_for_rejection"
                    as="textarea"
                    required="required"
                    cols="10"
                    rows="5"
                    className="form-control"
                  ></Field>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}

// const RejectRequestModal = ({rejectRequest,alert, toggle, modal, request,requested,approved}) =>
//     modal
//         ? ReactDOM.createPortal(
//               <React.Fragment>
//                   <div
//                       className="reactmodal fades"
//                       id="createAssetModal"
//                       role="dialog"
//                       aria-labelledby="myModalLabel"
//                       aria-hidden="true"
//                   >
//                       <div className="modal-dialog modal-sm" role="document">
//                           <div className="modal-content conmodal high-1">
//                               <div className="modal-header">
//                                   <h4
//                                       className="modal-title w-100"
//                                       id="myModalLabel"
//                                   >
//                                       Create Request
//                                   </h4>
//                                   <button
//                                       type="button"
//                                       className="close"
//                                       data-dismiss="modal"
//                                       aria-label="Close"
//                                       onClick={toggle}
//                                   >
//                                       <span aria-hidden="true">&times;</span>
//                                   </button>
//                               </div>
//                                 <Formik
//                         initialValues={{reason_for_rejection: ""}}
//                         onSubmit={(values) => {
//                             toggle()
//                             rejectRequest(request,values.reason_for_rejection,requested,approved)
//                           }}
//                     >
//                         {({isSubmitting}) => (
//                             <Form>

//                                   <div className="modal-body">
//                                       <div className="">

//                                           <div className="row">
//                                               <div className="col-md-12">
//                                                   <div className="form-group">
//                                                       <label>
//                                                       reason_for_rejection{" "}
//                                                           <span className="text-danger">
//                                                               {" "}
//                                                               *{" "}
//                                                           </span>
//                                                       </label>
//                                                       <Field
//                                                           name="reason_for_rejection"
//                                                           as="textarea"
//                                                           required="required"
//                                                           cols="10"
//                                                           rows="5"
//                                                           className="form-control"
//                                                       ></Field>
//                                                   </div>
//                                               </div>
//                                           </div>
//                                       </div>
//                                   </div>
//                                   <div className="modal-footer">
//                                       <button
//                                           type="button"
//                                           className="btn btn-danger btn-sm"
//                                           data-dismiss="modal"
//                                           onClick={toggle}
//                                       >
//                                           Close
//                                       </button>
//                                       <button
//                                           type="submit"
//                                           className="btn btn-block nt-button-color-default btn-sm"
//                                       >
//                                            Send Request
//                                           {/* <span
//                                               id="create_disciplinary_spinner"
//                                               className="fa fa-spin fa-spinner"
//                                           ></span> */}
//                                       </button>
//                                   </div>

//                             </Form>
//                         )}
//                     </Formik>
//                           </div>
//                       </div>
//                   </div>
//               </React.Fragment>,
//               document.body
//           )
//         : null;

// export default RejectRequestModal;



// WEBPACK FOOTER //
// ./src/container/dashboard/pending/model/rejectLeave.js